// src/utils/contact.js
import axios from './axios';

// Get all contacts
export const getAllContacts = () => {
  return axios.get('/contacts');
};

// Get contact count
export const getContactCount = () => {
  return axios.get('/contacts/count');
};

// Get a contact by ID
export const getContactById = (id) => {
  return axios.get(`/contacts/${id}`);
};

// Create a new contact
export const createContact = (contactData) => {
  return axios.post('/contacts', contactData);
};

// Update a contact by ID
export const updateContact = (id, updatedData) => {
  return axios.put(`/contacts/${id}`, updatedData);
};

// Delete a contact by ID
export const deleteContact = (id) => {
  return axios.delete(`/contacts/${id}`);
};

